var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon - check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6919 5.18306C16.936 5.42714 16.936 5.82286 16.6919 6.06694L7.94194 14.8169C7.69786 15.061 7.30214 15.061 7.05806 14.8169L2.68306 10.4419C2.43898 10.1979 2.43898 9.80214 2.68306 9.55806C2.92714 9.31398 3.32286 9.31398 3.56694 9.55806L7.5 13.4911L15.8081 5.18306C16.0521 4.93898 16.4479 4.93898 16.6919 5.18306Z",
    fill: "#66B927"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcn);
export default __webpack_public_path__ + "static/media/checkIcn.8a2addb2d57f643f01f019c6edba334f.svg";
export { ForwardRef as ReactComponent };